import { FC } from 'react';
import { TBaseTable } from '@mgm/common/components/table';
import { useFilter } from '../../../../hooks/useFilter';
import { CustomToolbar } from '../../../../components/table';
import { useInventoryFilters } from '../../hooks';

const InventoryTableHeader: FC<TBaseTable> = ({
  apiRef,
  printRef,
  handleScrollTable,
  isFullTable = false,
  setIsFullTable = () => {},
}) => {
  const { inventoryFilterItems } = useInventoryFilters();
  const { filterItems } = useFilter(inventoryFilterItems, false, true);

  return (
    <CustomToolbar
      handleScrollTable={handleScrollTable}
      printRef={printRef}
      filterItems={filterItems}
      apiRef={apiRef}
      isFullTable={isFullTable}
      setFullTable={setIsFullTable}
    />
  );
};

export {
  InventoryTableHeader,
};
